import React from 'react';
import { useDispatch } from 'react-redux';
import BaseButton from '../../baseButton';
import { SettingsActions } from '../../../redux/Settings';

const StartButton = () => {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(SettingsActions.startRogueLite());
  };

  return (
    <BaseButton
      onClick={onClick}
      alt="Start the game and roll some rules!"
      size="24"
      text="START!"
    />
  );
};

export default StartButton;
